import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { PageTitlePlaceholderLoader } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

import { TruncatedTextWithTooltip } from "app/pages/sales-intelligence/common-components/TruncatedText";

export const StyledOpportunitySpottedStack = styled(Stack)`
    justify-content: space-between;
    align-self: stretch;
    padding: 12px 16px 16px 12px;

    border-radius: 4px;
    background-color: ${colorsPalettes.bluegrey[100]};
`;

export const StyledOpportunitySpottedPlaceholderLoader = styled(PageTitlePlaceholderLoader)<{
    width: string;
    height: string;
}>`
    width: ${({ width }) => width} !important;
    height: ${({ height }) => height} !important;
    position: relative;

    & * {
        width: 100% !important;
        height: ${({ height }) => height} !important;
    }
`;

export const StyledOpportunitySpottedErrorText = styled(TruncatedTextWithTooltip)`
    font-weight: 700;
`;
